import {useContext, useEffect, useState} from 'react'
import {Col, Flex, Form, Modal, Row, Typography} from 'antd'
import {useIntl} from 'react-intl'
import {getRequest, postRequest, putRequest} from '../../../../services/base'
import {NavContext} from '../../../../context/global_context'
import {SET_SHOW_SUB_SYSTEM_POPUP, SubSystemContext,} from '../context/context'
import InputText from '../../../common/InputText'
import SelectInput from '../../../common/SelectInput'
import Button from '../../../common/Button'

const SubSystemFormModal = (props) => {
  const intl = useIntl()
  const [state, dispatch] = useContext(SubSystemContext)
  const [, navDispatch] = useContext(NavContext)
  const [form] = Form.useForm()
  const [systemOptions, setSystemOptions] = useState([])
  const [systemSearchFailed, setSystemSearchFailed] = useState(false)

  const selected = state?.selected_sub_system || {}
  const isEditing = !!selected?.id

  const closeFormPopup = () => {
    dispatch({ type: SET_SHOW_SUB_SYSTEM_POPUP, data: false })
    form.resetFields()
  }

  const getInitialValues = () => ({
    is_create: !isEditing,
    id: selected?.id || undefined,
    sub_system_id: selected?.sub_system_id || '',
    name: selected?.name || '',
    system: selected?.system || undefined,
  })

  const getSystemList = async (searchValue = '') => {
    let res = await getRequest(`/api/system/?search=${searchValue}`)
    // Search-as-you-type: shown in the dropdown, not as a toast per keystroke.
    if (res?.status === false) {
      setSystemSearchFailed(true)
      setSystemOptions([])
      return
    }
    setSystemSearchFailed(false)
    const results = res?.results || []
    setSystemOptions(
      results.map((item) => ({
        value: item.id,
        label: item.system_id ? `${item.name} (${item.system_id})` : item.name,
        name: item.name,
        system_id: item.system_id || '',
      }))
    )
  }

  useEffect(() => {
    if (!state.show_sub_system_popup) return
    getSystemList('')
  }, [state.show_sub_system_popup])

  useEffect(() => {
    if (!state.show_sub_system_popup) return
    form.setFieldsValue(getInitialValues())
  }, [state.show_sub_system_popup])

  const saveSubSystem = async (values) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: intl.formatMessage({ id: 'subSystem.save' }),
        showLoader: true,
      },
      notification: {},
    })

    const formData = new FormData()
    Object.entries(values).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value)
      }
    })

    const res = isEditing
      ? await putRequest(`/api/sub_system/${selected.id}/`, formData)
      : await postRequest(`/api/sub_system/`, formData)

    navDispatch({
      type: 'loader',
      data: { showLoader: false },
      notification: {},
    })

    if (res?.status) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: intl.formatMessage({
            id: isEditing
              ? 'subSystem.updateSuccess'
              : 'subSystem.saveSuccess',
          }),
        },
      })
      props.getSubSystemListData()
      closeFormPopup()
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: intl.formatMessage({ id: 'subSystem.saveError' }),
        },
      })
    }
  }

  return (
    <Modal
      open={state.show_sub_system_popup}
      title={
        isEditing
          ? intl.formatMessage({ id: 'subSystem.updateTitle' })
          : intl.formatMessage({ id: 'subSystem.createTitle' })
      }
      width="50%"
      centered={true}
      footer={null}
      closable={true}
      onCancel={closeFormPopup}
    >
      <div className="container">
        <Form
          id="sub-system-form"
          name="sub-system-form"
          form={form}
          layout="vertical"
          onFinish={saveSubSystem}
        >
          <InputText name="is_create" hidden={true} isRequired={false} />
          <InputText name="id" hidden={true} isRequired={false} />
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <InputText
                name="sub_system_id"
                label={intl.formatMessage({ id: 'subSystem.subSystemId' })}
                isRequired={true}
              />
            </Col>
            <Col span={12}>
              <InputText
                name="name"
                label={intl.formatMessage({ id: 'subSystem.name' })}
                isRequired={true}
              />
            </Col>
            <Col span={12}>
              <SelectInput
                name="system"
                label={intl.formatMessage({ id: 'subSystem.system' })}
                options={systemOptions}
                notFoundContent={
                  systemSearchFailed ? (
                    <Typography.Text type="danger" style={{ color: 'var(--color-form-link-danger)' }}>
                      {intl.formatMessage({ id: 'generic.searchFailed' })}
                    </Typography.Text>
                  ) : undefined
                }
                placeholder={intl.formatMessage({ id: 'subSystem.system' })}
                isRequired={true}
                onInputChange={(value) => {
                  getSystemList(value)
                }}
                allowClear={true}
                showSearch={true}
                filterOption={(input, option) => {
                  const text = (input || '').toLowerCase()
                  return (
                    (option?.name || '').toLowerCase().includes(text) ||
                    (option?.system_id || '').toLowerCase().includes(text)
                  )
                }}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Flex justify="end" className="py-4">
                <Button onClick={() => form.submit()} type="primary">
                  {intl.formatMessage({ id: 'subSystem.save' })}
                </Button>
              </Flex>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  )
}

export default SubSystemFormModal
